import React from "react"
import { useDispatch, useSelector } from "react-redux";
import {
  appdataSelector,
  appdata_getDeactivatedVendors,
  appdata_getPOsForVendor,
  appdata_setActiveRequestState,
  appdata_setActiveRequestType,
  appdata_setSnackbar
} from "reducers/appdata/appdata";
import {
  vendor_save_to_sap,
  vendordataSelector,
  vendordata_clearAllVendorData,
  vendordata_setSavedToSAP,
  vendordata_updateActiveVendor
} from "reducers/vendordata/vendordata";
import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import { useEffect } from "react";
import FileUploader from "components/MediaTel/FileUploader";
import FileViewer from "components/MediaTel/FileViewer";
import Button from "@mui/material/Button";
import classnames from "classnames";
import Loader from "components/Loading/Loader";
import Feedback from "../../partials/Feedback";

function Reactivate() {
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();
  

  useEffect(() => {
    console.log("NEW REACTIVATE");

    if (!appdata.isResetRequest) {
      dispatch(vendordata_clearAllVendorData());
    }

    if (appdata.activeRequestType != appdata.requestTypes.REACTIVATE_VENDOR) {
      dispatch(
        appdata_setActiveRequestType(appdata.requestTypes.REACTIVATE_VENDOR)
      );
    }

    if (appdata.activeRequestState != appdata.requestStates.CREATE) {
      dispatch(appdata_setActiveRequestState(appdata.requestStates.CREATE));
    }

    if (vendordata.savedToSAP) {
      dispatch(vendordata_setSavedToSAP(false));
    }
  }, []);


  let typeOfRequest = "";
  let companySelected = "";
  let vendorSelected = "";
  let POSelected = "";

  if (vendordata.activeVendor.master) {
    appdata.listvalues.requestTypeDropdownValues.map((item, key) => {
      if (item["VALUE"] === vendordata.activeVendor.master.VEND_TYP)
        typeOfRequest = item;
    });

    appdata.listvalues.companyDropdownValues.map((item, key) => {
      if (item["BUKRS"] === vendordata.activeVendor.master.BUKRS)
        companySelected = item;
    });

    if (
      appdata.listvalues.deactivatedVendorsForCompany &&
      Object.keys(appdata.listvalues.deactivatedVendorsForCompany).length > 0
    ) {
      appdata.listvalues.deactivatedVendorsForCompany.map((item, key) => {
        if (item["LIFNR"] === vendordata.activeVendor.master.LIFNR)
          vendorSelected = item;
      });
    }

    if (
      appdata.listvalues.purchasingOrganisations &&
      Object.keys(appdata.listvalues.purchasingOrganisations).length > 0
    ) {
      appdata.listvalues.purchasingOrganisations.map((item, key) => {
        if (item["EKORG"] === vendordata.activeVendor.master.EKORG)
          POSelected = item;
      });
    }
  }

  const handleSelectChange = (value, type = null) => {
    console.log("handle select change", value, type);

    dispatch(
      vendordata_updateActiveVendor({ part: "master", key: type, value: value })
    );


    if (type == "BUKRS" || type == "EKORG") {
      dispatch(appdata_getDeactivatedVendors());
    }


  };

  const showNoDeactivatedVendorsMessage = () => {
    if (
      (companySelected || POSelected) &&
      appdata.listvalues.deactivatedVendorsForCompany &&
      Object.keys(appdata.listvalues.deactivatedVendorsForCompany).length > 0 &&
      appdata.listvalues.deactivatedVendorsForCompany[0]["LIFNR"] == ""
    ) {
      return true;
    }
    return false;
  };

  const showDeactivatedVendorsDropdown = () => {

    if (vendordata && vendordata.activeVendor && vendordata.activeVendor.master && vendordata.activeVendor.master.BACK_2_REQUESTOR){
      return true;
    }
    
    if (
      companySelected &&
      appdata.listvalues.deactivatedVendorsForCompany &&
      Object.keys(appdata.listvalues.deactivatedVendorsForCompany).length > 0 &&
      appdata.listvalues.deactivatedVendorsForCompany[0]["LIFNR"] != ""
    ) {
      return true;
    }
    return false;
  };

  const showPurchasingOrganisationsDropdown = () => {

    return true;

    if (
      companySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] != ""
    ) {
      return true;
    }
    return false;
  };

  const showNOPOsWarning = () => {
    if (
      companySelected &&
      vendorSelected &&
      appdata.listvalues.POsForVendor &&
      Object.keys(appdata.listvalues.POsForVendor).length > 0 &&
      appdata.listvalues.POsForVendor[0]["EKORG"] == ""
    ) {
      return true;
    }
    return false;
  };

  const allowSave = () => {
    if (
      vendordata.activeVendor.master &&
      vendordata.activeVendor.master.BUKRS &&
      vendordata.activeVendor.master.LIFNR
    ) {
      return true;
    }
    return false;
  };

  const handleSave = () => {
    dispatch(appdata_setSnackbar({ open: true, message: "Saving..." }));
    dispatch(vendor_save_to_sap());
  };

  if (vendordata.savedToSAP) {
    return (
      <Feedback header="Reactivate Vendor"></Feedback>
    );
  }

  let containerClass = "no-breadcrumb chapter mt-4";
  if (!appdata.isResetRequest) {
    containerClass += " container-fluid"
  }


  return (
    <article className="article">
      <div className={containerClass}>

        {!appdata.isResetRequest && (
          <h2 className="article-title">Reactivate Vendor</h2>
        )}

        {appdata.isResetRequest && (
          <React.Fragment>
            <h2 className="article-title">
              Update Request
            </h2>
            <div className="mt-2">
              <b>Message: {vendordata.activeVendor.master.ZCOMMENT}</b>
            </div>
          </React.Fragment>
        )}



        <div className="mt-4">
          {/* type of request */}
          {/* type of request */}
          {/* type of request */}
          {/* type of request */}
          {renderDropdown(
            "Type of request",
            appdata.listvalues.requestTypeDropdownValues,
            typeOfRequest,
            "VEND_TYP",
            "VALUE",
            ["VALUE", "DESCRIPTION"],
            handleSelectChange
          )}
          {/* company */}
          {/* company */}
          {/* company */}
          {/* company */}
          {renderDropdown(
            "Company",
            appdata.listvalues.companyDropdownValues,
            companySelected,
            "BUKRS",
            "BUKRS",
            ["BUKRS", "BUTXT"],
            handleSelectChange,
            40
          )}

          {/* purchasing organisation */}
          {/* purchasing organisation */}
          {/* purchasing organisation */}
          {/* purchasing organisation */}
          {showPurchasingOrganisationsDropdown() &&
            renderDropdown(
              "Purchasing organisation",
              appdata.listvalues.purchasingOrganisations,
              POSelected,
              "EKORG",
              "EKORG",
              ["EKORG", "EKOTX"],
              handleSelectChange,
              40
            )}


          {/* no deactivated vendors found */}
          {/* no deactivated vendors found */}
          {/* no deactivated vendors found */}
          {/* no deactivated vendors found */}
          {/* no deactivated vendors found */}
          {showNoDeactivatedVendorsMessage() && (
            <div className="mt-4">
              <b>No deactivated vendors for Company or Purchasing Organisation found</b>
            </div>
          )}
          {/* deactivated vendors */}
          {/* deactivated vendors */}
          {/* deactivated vendors */}
          {/* deactivated vendors */}
          {/* deactivated vendors */}
          {showDeactivatedVendorsDropdown() &&
            renderDropdown(
              "Vendor",
              appdata.listvalues.deactivatedVendorsForCompany,
              vendorSelected,
              "LIFNR",
              "LIFNR",
              ["LIFNR", "NAME1"],
              handleSelectChange
            )}

          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* no purchasing organistations warning */}
          {/* {showDeactivatedVendorsDropdown() && showNOPOsWarning() && (
            <div className="mt-4">
              {" "}
              No Purchasing organisations found for vendor{" "}
            </div>
          )} */}


          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {showDeactivatedVendorsDropdown() && (
            <FileUploader></FileUploader>
          )}

          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {showDeactivatedVendorsDropdown() && <FileViewer enableRemove={appdata.isResetRequest}></FileViewer>}

          {/* save button */}
          {/* save button */}
          {/* save button */}
          {/* save button */}
          {allowSave() && !vendordata.saving && (
            <Button
              className={classnames("besiButton", "d-print-none", "mt-5")}
              variant="contained"
              key="savebutton"
              onClick={() => handleSave()}
            >
              Save
            </Button>
          )}

          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {vendordata.saving && (
            <div className="mt-4">
              <Loader size="30"></Loader>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
export default Reactivate;
